
var BOLD = BOLD || {};
var JerseyBuilderInstances = [];

/*==================================================
    # Main Function
==================================================*/
BOLD.JerseyBuilder = function(options, namespace){

    var $form = $(options.option_product.form)
    var $imageContainer = $('.jersey-builder-main-image[data-product-id="' + options.product_id + '"]')

    this.namespace = namespace;
    JerseyBuilderInstances.push(this);

    this.cachedVariables = {
        productId: options.product_id,
        $form: $form,
        $nameField: $form.find('.custom-name'),
        $numberField: $form.find('.custom-number'),
        $playerField: $form.find('[name="properties[Player]"]'),
        $imageContainer: $imageContainer,
        $namePreview: $imageContainer.find('.jersey-builder-inner-name'),
        $numberPreview: $imageContainer.find('.jersey-builder-number'),
        selectedPlayer: null,
        customName: 'Any Name',
        customNumber: '00',
        initialName: null,
        initialNumber: null,
        numberLimit: 2,
        nameLimit: BOLD.JerseyBuilderConfig.nameLimit,
        $numbers: $form.find('.numbers[data-number]'),
        $specialNumbers: $form.find('.special-numbers[data-number]'),
        $variantSelector: $form.find('.single-option-selector'),
        $addButton: $form.find('.button-cart'),
        $productVariants: $form.find('.product-variants')
    }


    this.cachedVariables.initialName = this.cachedVariables.customName;
    this.cachedVariables.initialNumber = this.cachedVariables.customNumber;

    this.cachedVariables.$numberField.attr('maxlength', this.cachedVariables.numberLimit).val(this.cachedVariables.customNumber);
    this.cachedVariables.$nameField.attr('maxlength', this.cachedVariables.nameLimit).val(this.cachedVariables.customName);

    this.checkVariantSelection();
    this.eventListeners();
    this.updatePreview('name', this.cachedVariables.customName);
    this.updatePreview('number', this.cachedVariables.customNumber);
    this.cachedVariables.$variantSelector.change();
}


/*==================================================
    # Event Listeners
==================================================*/
BOLD.JerseyBuilder.prototype.eventListeners = function(){

    /* On name input change, update name preview */
    this.cachedVariables.$nameField.on('keyup', function(event){
        var $element = $(event.target);
        var value = $element.val();
        if(value != this.cachedVariables.customName){
            this.cachedVariables.customName = value;
            this.cachedVariables.$playerField.val('').change();
            this.updatePreview('name', value);
        }
    }.bind(this));

    /* On number input change, update number preview */
    this.cachedVariables.$numberField.on('keyup', function(event){
        var $element = $(event.target);
        var value = $element.val();
        if(value != this.cachedVariables.customNumber){
            this.cachedVariables.customNumber = value;
            this.cachedVariables.$playerField.val('').change();
            this.updatePreview('number', value);
        }
    }.bind(this));

    /* On window resize, trigger update for name and number preview */
    $(window).resize(function() {
        this.updatePreview('name', this.cachedVariables.$nameField.val());
        this.updatePreview('number', this.cachedVariables.$numberField.val());
    }.bind(this));

    /* Prevent numbers from being entered on name field */
    this.cachedVariables.$nameField.on('keydown', function(event){
        var charCode = (event.which) ? event.which : event.keyCode;
        // Allow backspaces, spaces, hyphens, and arrow keys
        if(charCode == 8 || charCode == 32 || charCode == 189 || charCode == 37 || charCode == 39){
            return true;
        }
        var character = String.fromCharCode(charCode);
        var pattern = new RegExp(/[A-Za-z]/g);
        if(!pattern.test(character)){
            event.preventDefault();
            return false;
        }
    });

    /* Prevent letters from being entered on number field */
    this.cachedVariables.$numberField.on('keydown', function(event){
        var charCode = (event.which) ? event.which : event.keyCode;
            console.log('keycode', event.keycode);

        // Allow backspaces and arrow keys
        if(charCode == 8 || charCode == 37 || charCode == 39 || (charCode > 95 && charCode < 106)){
            return true;
        }
        var character = String.fromCharCode(charCode);
        var pattern = new RegExp(/[A-Za-z]/g);
        if(pattern.test(character)){
            event.preventDefault();
            return false;
        }
    });

    /* On variant change, enable add to cart button */
    this.cachedVariables.$variantSelector.on('change', function(event){
        this.checkVariantSelection();
    }.bind(this));

    /* On add to cart, check to see if name and number field have changed */
    this.cachedVariables.$addButton.on('click', function(event){
        this.removeError();
        if(this.cachedVariables.$numberField.val() == this.cachedVariables.initialNumber && this.cachedVariables.$nameField.val() == this.cachedVariables.initialName){
            event.preventDefault();
            this.displayError('Please select a player or enter a custom name and number');
        }
    }.bind(this));
}

/*==================================================
    # Remove Error
==================================================*/
BOLD.JerseyBuilder.prototype.removeError = function(){
    this.cachedVariables.$form.find('.error-message').remove();
}

/*==================================================
    # Display Error
==================================================*/
BOLD.JerseyBuilder.prototype.displayError = function(message){
    this.cachedVariables.$productVariants.after('<div class="error-message">' + message + '</div>');
}

/*==================================================
    # Check Variant Selection
==================================================*/
BOLD.JerseyBuilder.prototype.checkVariantSelection = function(){
    if(!this.cachedVariables.$variantSelector.val()){
        this.cachedVariables.$addButton.prop('disabled', true);
    }
    else {
        this.cachedVariables.$addButton.prop('disabled', false);
    }
}

/*==================================================
    # Player Change
      * On product options player input change,
        update name and number preview.
==================================================*/
BOLD.JerseyBuilder.prototype.playerChange = function(option){
    var value = option.value;
    if(value==''){
        return;
    }
    var name = value.split(',')[0];
    var number = value.split('#')[1];
    if(value !== this.cachedVariables.selectedPlayer){
        this.cachedVariables.selectedPlayer = value;
        this.cachedVariables.customName = name;
        this.cachedVariables.customNumber = number;
        this.cachedVariables.$nameField.val(name);
        this.cachedVariables.$numberField.val(number);
        this.updatePreview('name', name);
        this.updatePreview('number', number);
    }
}

/*==================================================
    # Update Preview
==================================================*/
BOLD.JerseyBuilder.prototype.updatePreview = function(type, value){
    switch(type){
        case 'name':
            this.cachedVariables.$namePreview.text(value);
            break;
        case 'number':
            this.numberPreview(value);
            break;
        default:
            return true;
    }
}

/*==================================================
    # Number Preview
      * Find number image dom nodes and append them
        to number preview.
      * Calculate height of the images based on 
        parent height.
==================================================*/
BOLD.JerseyBuilder.prototype.numberPreview = function(value){
    var numbers = value.split('').map(function(number, index, self){
        if(index == 0 && this.cachedVariables.$specialNumbers.length > 0 && self.length > 1){
            return this.cachedVariables.$specialNumbers.filter('[data-number="'+number+'"]').first().clone();
        }
        else {
            return this.cachedVariables.$numbers.filter('[data-number="'+number+'"]').first().clone();
        }
    }.bind(this));

    this.cachedVariables.$numberPreview.html(numbers);
    var parentHeight = this.cachedVariables.$numberPreview.height();

    this.cachedVariables.$numberPreview.find('img').height(parentHeight + 'px');
}

/*==================================================
    # On Options Loaded
      * Triggered by the product options app on 
        load.
==================================================*/
BOLD.findJerseyInstance = function(namespace){
    var instance = null;

    return JerseyBuilderInstances.filter(function(value, index){
        return value.namespace == namespace;
    });
}

/*==================================================
    # Change Property Names
==================================================*/
BOLD.JerseyBuilder.prototype.changePropertyNames = function(){
    this.cachedVariables.$playerField = this.cachedVariables.$form.find('[name="properties[Player]"]');
    this.cachedVariables.$playerField.attr('name', 'properties[Personalization1]');
    this.cachedVariables.$nameField.attr('name', 'properties[Personalization2]');
    this.cachedVariables.$numberField.attr('name', 'properties[Personalization3]');
}


/*==================================================
    # On Options Loaded
      * Triggered by the product options app on 
        load.
==================================================*/
 BOLD.options.app.on('options_loaded', function(data){
     if(data.namespace){
         new BOLD.JerseyBuilder(data.data, data.namespace);
     }
 });

/*==================================================
    # On Option Changed
      * Triggered by the product options app on 
        option change.
==================================================*/
BOLD.options.app.on('option_changed', function(data){
    if(data.namespace){
        if(data.data.option.publicName == 'Player'){
            var instances = BOLD.findJerseyInstance(data.namespace);
            if(instances){
                instances[0].playerChange(data.data);
                instances[0].changePropertyNames();
            }
        }
    }
});

/*==================================================
    # On Add To Cart Cloned
      * Triggered by the product options app when 
        add to cart is cloned.
==================================================*/
BOLD.options.app.on('add_to_cart_cloned', function(data){
    if(data.namespace){
        var instances = BOLD.findJerseyInstance(data.namespace);
        if(instances){
            instances[0].cachedVariables.$addButton = instances[0].cachedVariables.$form.find('.button-cart');
            instances[0].checkVariantSelection();
        }
    }
});

BOLD.options.app.on('adding_to_cart', function(data){
  if(data.namespace){
        var instances = BOLD.findJerseyInstance(data.namespace);
        if(instances){
            instances[0].changePropertyNames();
        }
    }
});